<div class="subheader with-padding flgrow" style="position: relative;">
    <div class="d-flex align-items-center">
        <div class="row align-items-center flex flex-grow-1">
            <div class="col-lg-4 col-md-6 col-sm-8 maxw600">
                <div class="d-flex">
                    <div class="flex-grow-1">
                        <div class="input-group">
                            <input class="form-control" type="text" name="searchTerm"
                                placeholder="{{ 'lblQuicksearch' | translate }}" [(ngModel)]="searchTerm"
                                autocomplete="off" (ngModelChange)="onQuickSerch()" />
                            <div class="input-group-append">
                                <button type="button" class="btn btn-primary" (click)="onQuickSerch()"
                                    aria-label="Center Align">
                                    <em class="fa fa-search" aria-hidden="true"></em>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto pl-0">
                <div class="date filter-field">
                    <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions"
                        class="form-control" placeholder="{{ 'lblBookedDateRange' | translate }}"
                        [(ngModel)]="bookedDate" (ngModelChange)="onBookedDateChange()" required />
                </div>
            </div>
            <div class="col-auto pl-0" *ngIf="dealerList && dealerList.length > 0">
                <div class="filter-field">
                    <app-dealer-searchbox-dropdown [dealerList]="dealerList" [ngModel]="dealerSelected"
                        ngDefaultControl name="dealerDropdown" [selectedDealer]="dealerId"
                        (onSelectDealer)="onDealerSelected($event)">
                    </app-dealer-searchbox-dropdown>
                </div>
            </div>
            <div class="col-auto pl-0">
                <div class="filter-field">
                    <select class="form-control" name="sourceFilter" [(ngModel)]="selectedSource"
                        (ngModelChange)="onSourceSelected()">
                        <option [ngValue]="null" translate>All</option>
                        <option *ngFor="let item of sourceList" [ngValue]="item.value">{{ item.text }}</option>
                    </select>
                </div>
            </div>
            <div class="col-auto pl-0">
                <button type="button" class="btn btn-outline-tertiary" (click)="onReset()" translate
                    aria-label="Center Align">lblReset</button>
            </div>
        </div>
        <div class="pl-2 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">
            <a class="btn btn-outline-primary" href="javascript:void(0);" (click)="getReportList()"
                aria-label="Center Align">
                <em class="fas fa-sync fa-lg"></em>
            </a>
        </div>
    </div>
</div>

<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="kpi-grid mb-3">
                <div class="kpi-card">
                    <span class="kpi-ico-box"><em class="fas fa-calendar-check"></em></span>
                    <div class="kpi-body">
                        <div class="kpi-top">
                            <span class="kpi-label" translate>lblTotalAppointment</span>
                            <span class="kpi-pill" ngbTooltip="{{ 'lblCustomerWaiting' | translate }}"
                                placement="top" container="body">
                                <em class="fas fa-hourglass-half"></em>{{ customerStats.waiting }}
                            </span>
                        </div>
                        <div class="kpi-value">{{ totalCount }}</div>
                    </div>
                </div>
                <div class="kpi-card kpi-green">
                    <span class="kpi-ico-box"><em class="fas fa-users"></em></span>
                    <div class="kpi-body">
                        <div class="kpi-top">
                            <span class="kpi-label" translate>lblCustomer</span>
                            <span class="kpi-pill" ngbTooltip="{{ 'lblRepeatCustomers' | translate }}"
                                placement="top" container="body">
                                <em class="fas fa-repeat"></em>{{ customerStats.repeat }}
                            </span>
                        </div>
                        <div class="kpi-value">{{ customerStats.unique }}</div>
                    </div>
                </div>
                <div class="kpi-card kpi-orange">
                    <span class="kpi-ico-box"><em class="fas fa-coins"></em></span>
                    <div class="kpi-body">
                        <div class="kpi-top">
                            <span class="kpi-label" translate>lblTotalCost</span>
                            <span class="kpi-pill" ngbTooltip="{{ 'lblServices' | translate }}"
                                placement="top" container="body">
                                <em class="fas fa-tags"></em>{{ serviceItems.length }}
                            </span>
                        </div>
                        <div class="kpi-value">
                            {{ totalServiceCost | number : '1.0-0' }}
                            <span class="kpi-unit">{{ currency }}</span>
                        </div>
                    </div>
                </div>
                <div class="kpi-card kpi-dark">
                    <span class="kpi-ico-box"><em class="fas fa-bullhorn"></em></span>
                    <div class="kpi-body">
                        <div class="kpi-top">
                            <span class="kpi-label" translate>lblMarketingConsent</span>
                            <span class="kpi-pill">{{ customerStats.consent }}/{{ totalCount }}</span>
                        </div>
                        <div class="kpi-value">
                            {{ customerStats.consentPercent }}<span class="kpi-unit">%</span>
                        </div>
                    </div>
                    <div class="kpi-meter">
                        <div class="kpi-meter-fill" [style.width.%]="customerStats.consentPercent"></div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-4 col-lg-6 mb-3">
                    <div class="card h-100 chart-card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <span translate>lblBrandWiseAppointment</span>
                            <button type="button" class="btn btn-outline-tertiary btn-sm" *ngIf="selectedBrand"
                                (click)="clearFilter(true)">
                                {{ selectedBrand }} &nbsp;<em class="fas fa-times"></em>
                            </button>
                        </div>
                        <div class="card-body">
                            <div class="d-flex align-items-center" *ngIf="brandChartLabels.length > 0; else noBrand">
                                <div class="donut-wrap">
                                    <canvas baseChart [datasets]="brandChartData" [labels]="brandChartLabels"
                                        [options]="doughnutOptions" [legend]="false" [type]="'doughnut'"
                                        (chartClick)="onBrandChartClick($event)"></canvas>
                                    <div class="donut-center">
                                        <div class="donut-total">{{ totalCount }}</div>
                                        <div class="donut-label" translate>lblTotal</div>
                                    </div>
                                </div>
                                <div class="flex-grow-1 pl-3 chart-scroll">
                                    <div class="legend-row" *ngFor="let label of brandChartLabels; let i = index"
                                        [class.is-active]="selectedBrand === label" (click)="selectBrand(label)">
                                        <span class="legend-dot"
                                            [style.background-color]="chartPalette[i % chartPalette.length]"></span>
                                        <span class="legend-name" [title]="label">{{ label }}</span>
                                        <span class="legend-value">{{ brandCounts[label] }}</span>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noBrand>
                                <div class="no-data" translate>lblNoRecordsFound</div>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 mb-3">
                    <div class="card h-100 chart-card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <span translate>lblServiceWiseAppointment</span>
                            <button type="button" class="btn btn-outline-tertiary btn-sm" *ngIf="selectedService"
                                (click)="clearFilter(false)">
                                {{ selectedService }} &nbsp;<em class="fas fa-times"></em>
                            </button>
                        </div>
                        <div class="card-body">
                            <div class="chart-scroll" *ngIf="serviceItems.length > 0; else noService">
                                <div class="svc-row" *ngFor="let item of serviceItems"
                                    [class.is-active]="selectedService === item.name"
                                    [class.is-dim]="selectedService && selectedService !== item.name"
                                    ngbTooltip="{{ (item.amountInclVAT | number : '1.2-2') + ' ' + ('lblInclVAT' | translate) }}"
                                    placement="top" container="body"
                                    (click)="selectService(item.name)">
                                    <span class="svc-fill" [style.width.%]="item.percent"></span>
                                    <span class="svc-name" [title]="item.name">{{ item.name }}</span>
                                    <span class="svc-count">
                                        {{ item.count }}
                                    </span>
                                    <span class="svc-amount"> {{ item.amount | number : '1.0-0' }} </span>
                                </div>
                            </div>
                            <ng-template #noService>
                                <div class="no-data" translate>lblNoRecordsFound</div>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12 mb-3">
                    <div class="card h-100 chart-card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <span translate>lblTopCustomers</span>
                            <span class="hdr-note">{{ customerStats.unique }}</span>
                        </div>
                        <div class="card-body">
                            <div class="chart-scroll" *ngIf="topCustomers.length > 0; else noCustomer">
                                <div class="cust-row" *ngFor="let item of topCustomers; let i = index">
                                    <span class="cust-avatar"
                                        [style.background-color]="chartPalette[i % chartPalette.length]">
                                        {{ item.initials }}
                                    </span>
                                    <div class="cust-info">
                                        <div class="cust-name" [title]="item.name">{{ item.name }}</div>
                                        <div class="cust-meta" [title]="item.email">
                                            <em class="fas fa-envelope cust-ico"></em>{{ item.email }}
                                        </div>
                                    </div>
                                    <div class="cust-stat">
                                        <div class="cust-count">{{ item.count }}</div>
                                        <div class="cust-amount">{{ item.amount | number : '1.0-0' }} {{ currency }}</div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noCustomer>
                                <div class="no-data" translate>lblNoRecordsFound</div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
                    <span class="report-title">
                        <span translate>lblWidgetAppointmentReport</span>
                        <span class="report-count">({{ totalCount }})</span>
                    </span>
                    <div class="d-flex align-items-center flex-wrap status-legend">
                        <span class="status-chip status-chip-success">
                            <em class="fas fa-check-circle"></em>
                            <span translate>lblCompleted</span>
                        </span>
                        <span class="status-chip status-chip-primary">
                            <em class="fas fa-dot-circle"></em>
                            <span translate>lblInProgress</span>
                        </span>
                        <span class="status-chip status-chip-warning">
                            <em class="fas fa-clock"></em>
                            <span translate>lblPendingtoApprove</span>
                        </span>
                        <span class="status-chip status-chip-danger">
                            <em class="fas fa-trash-alt"></em>
                            <span translate>lblDeletedWidgetAppointment</span>
                        </span>
                    </div>
                </div>

                <div class="table-responsive max-h254">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th scope="col" translate>lblWoNo</th>
                                <th scope="col" translate>lblRegNumber</th>
                                <th scope="col" translate>lblModel</th>
                                <th scope="col" translate>lblYear</th>
                                <th scope="col" translate>lblCustomer</th>
                                <th scope="col" translate>lblAddress</th>
                                <th scope="col" translate>lblDealersName</th>
                                <th scope="col" translate>lblServices</th>
                                <th scope="col" translate>lblPrice</th>
                                <th scope="col" translate>lblCreatedDate</th>
                                <th scope="col" translate>lblCustomerWaiting</th>
                                <th scope="col" translate>lblMarketingConsent</th>
                                <th scope="col" translate>lblTransportation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="displayList?.length > 0; else load_else">
                                <tr [class.click]="appointment.appointmentStatus !== 4" [class.row-disabled]="appointment.appointmentStatus === 4" *ngFor="let appointment of displayList; let i = index" (click)="onEdit(appointment)">
                                    <td>{{ i+1 }}</td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <span class="status-ico-wrap">
                                                <em class="fas fa-check-circle text-success fa-lg"
                                                    *ngIf="appointment.appointmentStatus === 3"
                                                    ngbTooltip="{{ 'lblCompleted' | translate }}" placement="top"
                                                    container="body"></em>
                                                <em class="fas fa-dot-circle text-primary fa-lg"
                                                    *ngIf="appointment.appointmentStatus === 2"
                                                    ngbTooltip="{{ 'lblInProgress' | translate }}" placement="top"
                                                    container="body"></em>
                                                <em class="fas fa-clock text-warning fa-lg"
                                                    *ngIf="appointment.appointmentStatus === 1"
                                                    ngbTooltip="{{ 'lblPendingtoApprove' | translate }}" placement="top"
                                                    container="body"></em>
                                                <em class="fas fa-trash-alt text-danger fa-lg"
                                                    *ngIf="appointment.appointmentStatus === 4"
                                                    ngbTooltip="{{ 'lblDeletedWidgetAppointment' | translate }}" placement="top"
                                                    container="body"></em>
                                            </span>
                                            <div>
                                                <div class="d-flex align-items-center wo-no" *ngIf="appointment.workOrderNumber != appointment.widgetAppointmentNo">
                                                    <ngb-highlight [result]="appointment.workOrderNumber">
                                                    </ngb-highlight>
                                                </div>
                                                <div class="wa-no">
                                                    #<ngb-highlight [result]="appointment.widgetAppointmentNo">
                                                    </ngb-highlight>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.licensePlate">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.model" [term]="appliedSearchTerm">
                                        </ngb-highlight>
                                    </td>
                                    <td>{{ appointment.year }}</td>
                                    <td>
                                        <ngb-highlight [result]="appointment.customerName" [term]="appliedSearchTerm">
                                        </ngb-highlight>
                                        <div class="d-flex align-items-center mt-1 fs-12px lh-16px"
                                            *ngIf="appointment.mobile">
                                            <em class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                            <span class="fs-12px" *ngIf="appointment.customerMobileCode">+{{
                                                appointment.customerMobileCode }}-</span>
                                            <ngb-highlight class="fs-12px" [result]="appointment.mobile">
                                            </ngb-highlight>
                                        </div>
                                        <div class="d-flex align-items-center fs-12px lh-16px"
                                            *ngIf="appointment.email">
                                            <em class="fas fa-envelope fs-10px fa-lg mr-2 clr666"></em>
                                            <ngb-highlight class="fs-12px" [result]="appointment.email"
                                                [term]="appliedSearchTerm">
                                            </ngb-highlight>
                                        </div>
                                    </td>
                                    <td>
                                        <ngb-highlight [term]="appliedSearchTerm"
                                            [result]="appointment.address + ', ' + appointment.postcode + ', ' + appointment.city">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.dealerName">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.serviceNames">
                                        </ngb-highlight>
                                    </td>
                                    <td>{{ appointment.price | number : '1.2-2' }}</td>
                                    <td>
                                        <ngb-highlight [result]="appointment.createdDate | date:'short'">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <em class="fas fa-check fa-lg" *ngIf="appointment.isCustomerWaiting"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="!appointment.isCustomerWaiting"></em>
                                    </td>
                                    <td>
                                        <em class="fas fa-check fa-lg" *ngIf="appointment.isMarketingConsent"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="!appointment.isMarketingConsent"></em>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="appointment.transportSolution">
                                        </ngb-highlight>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="16" class="no-record" translate>
                                        lblNoRecordsFound
                                    </td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
